import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { GraphqlService } from "../../shared/services/graphql.service";

@Injectable({ providedIn: 'root' })
export class UserService {
  private http = inject(HttpClient); 
  private graphqlService = inject(GraphqlService);

  permissions$: any = [
    { id: 'VIEW_INTOUCH_PROGRESS_ORDERS', name: 'View InTouch Orders (InTouch)' },
    { id: 'UPLOAD_INTOUCH_ARTWORK', name: 'Upload InTouch Artwork (InTouch)' },
    { id: 'REPLACE_INTOUCH_ARTWORK', name: 'Replace InTouch Artwork (InTouch)' },
    { id: 'FETCH_INTOUCH_ORDERS', name: 'Fetch InTouch Orders (InTouch)' },
    { id: 'UPDATE_INTOUCH_ORDERS', name: 'Update InTouch Orders (InTouch)' },
    { id: 'FORCE_UPDATE_INTOUCH_ORDERS', name: 'Force Update InTouch Orders (InTouch)' },

    { id: 'VIEW_AVERY_PROGRESS_ORDERS', name: 'View Avery Orders (Avery)' },
    { id: 'FETCH_AVERY_ORDERS', name: 'Fetch Avery Orders (Avery)' },
    { id: 'PUSH_AVERY_ORDER_TO_INTOUCH', name: 'Push Avery Order to InTouch (Avery)' },
    { id: 'REPLACE_AVERY_ARTWORK', name: 'Replace Avery Artwork (Avery)' },
    { id: 'UPDATE_AVERY_ORDERS', name: 'Update Avery Orders (Avery)' },
    { id: 'CANCEL_AVERY_ORDER', name: 'Cancel Avery Order (Avery)' },

    { id: 'VIEW_ORDERS', name: 'View Orders' },

    { id: 'EDIT_INTOUCH_TICKET', name: 'Edit InTouch Ticket (InTouch)' },
    { id: 'EDIT_AVERY_ORDER_DETAILS', name: 'Edit Avery Order Details (InTouch)' },
    { id: 'RESYNC_AVERY_ORDER_ARTWORKS', name: 'ReSync Avery Order Artworks (Avery)' },

    { id: 'VIEW_SETTINGS_MATERIAL_MAP', name: 'View Material Map (Settings)' },
    { id: 'CREATE_SETTINGS_MATERIAL_MAP', name: 'CREATE Material Map (Settings)' },
    { id: 'EDIT_SETTINGS_MATERIAL_MAP', name: 'EDIT Material Map (Settings)' },
    { id: 'DELETE_SETTINGS_MATERIAL_MAP', name: 'DELETE Material Map (Settings)' },
  ]
  constructor() {}

  getUserList() {
    const query = `{
      users(param: "all") 
      {   
        id
        username
        permissions
        isAdmin
        isActive
        updatedAt
        createdAt
      }
    }`
    console.log('usersList', query)
    return this.graphqlService.query(query);
  }

  getUser(recordId: any) {
    const query = `{
      user(id: "${recordId}") {
        id
        username
        permissions
        isAdmin
        isActive
        updatedAt
        createdAt
      }
    }`;

    const variables = { }; // Pass variables here
    return this.graphqlService.query(query, variables);
  }

  createUser(jsonData: any) {
    console.log("Data: ", jsonData)
    const variables = { data: jsonData };
    const query = `mutation($data: UserCreateInput!) {
      createUser(user: $data) {
        id
        username 
        permissions
        isAdmin 
        isActive
      }
    }`;

    return this.graphqlService.query(query, variables);
  }

  updateUser(jsonData: any) {
    console.log("Data: ", jsonData)
    const variables = { data: jsonData };
    const query = `mutation($data: UserInput!) {
      updateUser(user: $data) {
        id
        username
        permissions
        isAdmin
        isActive
      }
    }`;

    return this.graphqlService.query(query, variables);
  }
}